import {
  PickerButton as PickerButtonBase,
  type PickerButtonProps,
} from "@src/appV2/redesign/system/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function PickerButton(props: Omit<PickerButtonProps, "LinkComponent">) {
  return <PickerButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
